export default "__VITE_ASSET__C_W4wSnM__ 150w, __VITE_ASSET__BEpIFHDm__ 300w, __VITE_ASSET__B1RLuWFO__ 600w, __VITE_ASSET__Ksh6FOIA__ 793w";